// ERROR TYPES
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

//LOGIN SCREEN
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_RESET="LOGIN_RESET";

//PRE LOGIN SCREEN
export const PRE_LOGIN_REQUEST = "PRE_LOGIN_REQUEST";
export const PRE_LOGIN_SUCCESS = "PRE_LOGIN_SUCCESS";
export const PRE_LOGIN_FAILURE = "PRE_LOGIN_FAILURE";
export const PRE_LOGIN_RESET="PRE_LOGIN_RESET";

//SESSION CHECK
export const SESSION_CHECK_REQUEST = "SESSION_CHECK_REQUEST";
export const SESSION_CHECK_SUCCESS = "SESSION_CHECK_SUCCESS";
export const SESSION_CHECK_FAILURE = "SESSION_CHECK_FAILURE";
export const SESSION_CHECK_RESET="SESSION_CHECK_RESET";
export const SESSION_INVALIDATE="SESSION_INVALIDATE";

//LOGOUT
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";